/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
} from '@material-ui/core';
import examServices from '../../redux/services/examServices';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';
import { toastError, toastSuccess } from '../../redux/actions/alertActions';

const NumberOfStudents = ({ data }) => {
  const [nbStudents, setNbStudents] = useState(0);

  useEffect(() => {
    if (data.nbPapers === undefined) {
      if (data.examType === 2 && data.students) {
        let countResults = 0;
        let count = 0;
        data.students.forEach((student) => {
          examServices.getExamPDFResults(student._id)
            .then((res) => {
              count += 1;
              if (res.length > 0) {
                res.forEach((item) => {
                  if (item.examFile === data.examFile && item.answer.length > 0) {
                    countResults += res.length;
                  }
                });
              }
              if (count === data.students.length) {
                setNbStudents(countResults);
              }
            });
        });
      }
    } else {
      setNbStudents(data.nbPapers);
    }
  }, []);

  const handleNbStudents = (e) => {
    setNbStudents(e.target.value);
  };

  const saveNbStudents = () => {
    elearningDetailsServices.updateElearningOption(data.examId, { nbPapers: nbStudents })
      .then(() => toastSuccess('Nombre de copies mis à jour.'))
      .catch(() => toastError('Echec de la mise à jour.'));
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <TextField
        value={nbStudents}
        type="number"
        variant="outlined"
        multiline
        onChange={handleNbStudents}
        inputProps={{
          style: {
            color: '#6b6b6b',
            fontSize: '13px',
          },
        }}
      />
      <Button
        variant="outlined"
        color="primary"
        size="small"
        style={{
          marginTop: '10px',
          fontSize: '10px',
          alignSelf: 'flex-end',
        }}
        onClick={saveNbStudents}
      >
        Save
      </Button>
    </div>
  );
};

export default NumberOfStudents;
